import CTAButton from "./CTAButton";

export default function HardSellSection({ content = {}, productImage, onCheckout, canCheckout }) {
  const title = content.title || "";
  const desc = content.desc || "";
  const points = content.points || [];
  const ctaText = content.cta_text || "YA, Saya Mau Produk Ini";

  return (
    <section className="py-20 bg-background">
      <div className="mx-auto max-w-5xl px-5 grid lg:grid-cols-[1fr_1.2fr] gap-10 items-center">
        <img
          src={productImage}
          alt="Produk"
          className="rounded-3xl shadow-luxury aspect-square object-cover w-full"
        />
        <div>
          {title && (
            <blockquote className="font-display text-2xl sm:text-3xl font-bold leading-tight text-balance">
              "{title}"
            </blockquote>
          )}
          {desc && (
            <p className="mt-5 text-muted-foreground leading-relaxed">
              {desc}
            </p>
          )}
          {points.length > 0 && (
            <ul className="mt-6 space-y-2">
              {points.map((p, i) => (
                <li key={i} className="flex items-center gap-2 text-foreground">
                  <span>🌺</span> {p}
                </li>
              ))}
            </ul>
          )}
          <div className="mt-8">
            <CTAButton size="lg" pulse onClick={onCheckout} disabled={!canCheckout}>
              {ctaText}
            </CTAButton>
          </div>
        </div>
      </div>
    </section>
  );
}
